<template>
    <div class="baggage-list">
        <div
            v-if="hasItems"
            class="baggage-list-inner"
            :class="!showIncludedPerItem && 'is-row'">
            <div v-for="(item, index) in items" :key="index" class="baggage-list-item">
                <div class="baggage-list-item-label">
                    {{ getIncludedBaggageLabel(item, false, false) }}
                </div>
                <div class="baggage-badge" v-if="showIncludedPerItem">
                    <Translation :translate="{ key: 'checkout.included' }" />
                </div>
            </div>
        </div>
        <div v-else class="baggage-empty included">
            {{ noSelectionLabel }}
        </div>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { isEmpty } from 'lodash';
    import { BaggageIncluded, BaggageType } from '@shared/interfaces/baggage';
    import { getIncludedBaggageLabel } from '@shared/helpers/baggage';
    import Translation from '@ui/components/Translation/Translation.vue';

    export default defineComponent({
        name: 'List',
        components: { Translation },
        methods: { getIncludedBaggageLabel },
        props: {
            showIncludedPerItem: { type: Boolean, default: false },
            split: { type: Boolean, default: false },
            type: {
                type: String as PropType<BaggageType>,
                required: true,
            },
            items: {
                type: Array as PropType<BaggageIncluded[]>,
                default: () => [],
            },
            noBaggageSelectionCabinBagLabel: { type: String, required: true },
            noBaggageSelectionCheckedBagLabel: { type: String, required: true },
            noBaggageSelectionLabel: { type: String, required: true },
        },
        setup(props) {
            const hasItems = computed((): boolean => props.items && !isEmpty(props.items));

            const noSelectionLabel = computed(() => getNoSelectionLabel());

            const getNoSelectionLabel = () => {
                switch (props.type) {
                    case BaggageType.CabinBag:
                        return props.noBaggageSelectionCabinBagLabel;
                    case BaggageType.CheckedBag:
                        return props.noBaggageSelectionCheckedBagLabel;
                    default:
                        return props.noBaggageSelectionLabel;
                }
            };

            return { hasItems, noSelectionLabel };
        },
    });
</script>
